import { Component, OnInit } from '@angular/core';
import { HttpParams, HttpClient, HttpHeaders } from '@angular/common/http';
import { TSFuntionService } from '../../services/ts-funtion.service';
import { FormBuilder } from '@angular/forms';
import { SWAlertService } from '../../services/swalert.service';
import { DatePipe, DecimalPipe } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dailyprojectedcashflow',
  templateUrl: './dailyprojectedcashflow.component.html',
  styleUrls: ['./dailyprojectedcashflow.component.css']
})
export class DailyprojectedcashflowComponent implements OnInit {
  ranges: any;
  VendorNoResult: any;
  showDetail: boolean = true;
  lstData: any = [];
  sndData: Array<any> = [];
  public settings = {};
  public settingsStatus = {};
  arrCompany: Array<any> = [];
  nvendor: any = "";
  svendor: any = "";
  nComcode = [];
  arrStatus: any;
  arrVendor: any = [];
  DataVendor: any = [];
  nStatus: any = [];
  dReqDate: any;
  dDueDate: any = [];
  today: number = Date.now();
  today7 = new Date();
  dToday = this.datepipe.transform(this.today, 'dd/MM/yyyy')
  datarow_: any = [];
  arrDueDate: Array<any> = [];
  Currency: any;
  sCurrency: any;
  dDueDateFrom: any;
  dDueDateTo: any;
  Numdate: any;
  DataExport: any = [];
  OptionGrid = {
    nCurrentPage: 1,
    maxSize: 7,
    nPageSize: 10,
    nTotalItem: 0,
    ArrPageSize: [
      { sValue: 10 },
      { sValue: 20 },
      { sValue: 50 },
      { sValue: 100 },
      { sValue: 1000 },
      { sValue: 2000 },
      { sValue: 3000 },
      { sValue: 4000 },
      { sValue: 5000 },
      { sValue: 10000 },
    ]
  }
  txtPaytype: any;
  settings_PayType = {};
  arrPaytype: any = [];
  sDetailData = "";
  IsHeaderSort = "";
  SortDirection = "";
  SortICO = "fas fa-sort";
  IcoSort = "fas fa-sort";
  IcoSortDesc = "fas fa-sort-up";
  IcoSortAsc = "fas fa-sort-down";
  constructor(private formBuilder: FormBuilder, private http: HttpClient, private System: TSFuntionService, private SW: SWAlertService, public datepipe: DatePipe, private router: Router, private _decimalPipe: DecimalPipe) { }

  ngOnInit() {
    const ua = this.System.GetUserStorage();
    if (ua) {
      this.nComcode = [];
      ua.lstCompCode.forEach(f =>
        this.nComcode.push({COMPANY_CODE: f.sCompCode, COMPANY_NAME: f.sCompName})
      );
    }

    this.Status();
    this.loadCompany();
    this.setmultiselect();
    this.dDueDate[0] = this.dToday;
    this.dDueDate[1] = this.datepipe.transform(this.today7.setDate(this.today7.getDate() + 6), 'dd/MM/yyyy');

    this.SetHeadTable(this.dDueDate[0], this.dDueDate[1]);
    this.sCurrency = "THB";
    this.Search();
    this.loadCurrency();
    this.http.get<any>(this.System.SiteName + "api/DailyProjectd/PaymentType").toPromise().then(res => {
      this.arrPaytype = res
    });
    this.settings_PayType = {
      singleSelection: false,
      idField: 'nReqType',
      textField: 'sReqType',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false

    };
    this.loadVendor();


    let nsize = document.getElementById('dvbtn').offsetWidth;
    let width = "width:" + nsize + "px;overflow-x:auto;";
    document.getElementById('divFlowResize').setAttribute("style", width);
    document.getElementById('tb_rptdpf').setAttribute("style", "width:1800px");
    //document.getElementById("divFlowChart").style.width = (document.getElementById("divFlowResize").clientWidth - 5) + "px";
  }
  async loadCurrency() {
    //DropdownCurrency
    await this.http.get(this.System.SiteName + "api/Autocomplete/MT_CURRENCY/*").toPromise().then((data: Response) => {
      this.Currency = data;
    });
    this.sCurrency = "THB";
  }
  async loadCompany() {
    await this.http.get<any>(this.System.SiteName + "api/Autocomplete/MT_COMPANY_CODE/*").toPromise().then(res => {

      const ua = this.System.GetUserStorage();
      if ([3, 4, 5].includes(ua.nRole)) {
        this.arrCompany = res.filter(f => f.cActive == 'Y').filter(f => f.cActive == 'Y' && f.COMPANY_CODE === ua.sCompCode);
      }
      else {
        this.arrCompany = res.filter(f => f.cActive == 'Y');
      }
    })
  }
  async loadVendor() {
    let sComcode: string = this.nComcode.length > 0 ? this.nComcode.map(e => e.COMPANY_CODE).join(",") : "";
    const vendor = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("nComcode", sComcode)
    };
    await this.http.get(this.System.SiteName + "api/DailyProjectd/Getvendor", vendor).toPromise().then(data => {
      if (data) {
        this.DataVendor = data;
        this.arrVendor = this.DataVendor.map(re => ({ Vendor: re.VENDOR_CODE + " - " + re.sVendorName, VENDOR_CODE: re.VENDOR_CODE, sAddress: re.sAddress, sVendorName: re.sVendorName, TAX_NUMBER1: re.TAX_NUMBER1, TAX_NUMBER2: re.TAX_NUMBER2, TAX_NUMBER3: re.TAX_NUMBER3 }))
      } else {
        this.arrVendor = [];
      }
    })
  }
  async Status() {
    await this.http.get(this.System.SiteName + "api/DailyProjectd/GetStatus").toPromise().then(data => {
      this.arrStatus = data;
    })
  }
  onVendorSelect(event) {
    this.svendor = event.item.VENDOR_CODE;
    this.nvendor = event.item.VENDOR_CODE;
  }
  SelectDueDate(event) {

    this.dDueDateFrom = event[0];
    this.dDueDateTo = event[1];
    // this.SetHeadTable(this.datepipe.transform(event[0], 'dd/MM/yyyy'), this.datepipe.transform(event[1], 'dd/MM/yyyy'))
  }
  PageSizeChange() {
    setTimeout(() => {
      this.OptionGrid.nCurrentPage = 1;
      this.Search();
    });
  }

  PageChanged(event: any) {
    this.OptionGrid.nCurrentPage = event.page;
    this.Search();
  }
  async Search() {
    let _this = this;
    let pattern = new RegExp(/(\d{2})\/(\d{2})\/(\d{4})/);
    let from: any;
    let to: any;
    let isTruePattern = pattern.test(_this.dDueDate[0]);
    if (isTruePattern) {
      from = _this.dDueDate[0];
      to = _this.dDueDate[1];
    } else {
      from = this.datepipe.transform(_this.dDueDate[0], 'dd/MM/yyyy');
      to = this.datepipe.transform(_this.dDueDate[1], 'dd/MM/yyyy');
    }
    this.SetHeadTable(from, to);
    let Result: any;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let nStatus: string = this.nStatus.length > 0 ? this.nStatus.map(e => e.nStatusID).join(",") : "";
    let sComcode: string = this.nComcode.length > 0 ? this.nComcode.map(e => e.COMPANY_CODE).join(",") : "";
    let DataSearch = {
      company: sComcode,
      txtPaytype: this.txtPaytype != undefined ? this.txtPaytype.map(m => m.nReqType).join(",") : "",
      vendor: this.nvendor,
      nStatus: nStatus,
      dDueDateFrom: this.dDueDate != null ? from : "",
      dDueDateTo: this.dDueDate != null ? to : "",
      sCurrency: this.sCurrency,
    }
    let Json = JSON.stringify(DataSearch);
    await this.http.post(this.System.SiteName + "api/DailyProjectd/Search", Json, { headers, responseType: 'json' }).toPromise().then(data => Result = data)
    let nStartItemPage = 0;
    let nLastItemPage = 0;
    if (Result) {
      this.OptionGrid.nTotalItem = Result.length;
      let nPageSize = this.System.ParseIntToZero(this.OptionGrid.nPageSize)
      let nStartIndex_Take = (this.OptionGrid.nCurrentPage - 1) * nPageSize;
      let nEndIndex_Take = nPageSize;

      this.DataExport = Result;
      this.lstData = [];
      //this._ArrData.forEach(val => this._ArrDataBind.push(Object.assign({ cbSubDoc: val.sSupportDoc != null ? true : false }, val)));
      Result.forEach(val => this.lstData.push(Object.assign({}, val)));
      this.lstData = this.lstData.splice(nStartIndex_Take, nEndIndex_Take);
      nStartItemPage = nStartIndex_Take + 1;
      nLastItemPage = nStartIndex_Take + this.lstData.length;
      this.sDetailData = "Showing " + nStartItemPage + " to " + nLastItemPage + " of " + Result.length + " Rows";
    } else {
      this.lstData = [];
    }
    let arrData = [];
    let html = "";
    if (this.lstData.length > 0) {
      let num = this.lstData.length;
      for (let i = 0; i < num; i++) {
        this.datarow_[i] = false;
        this.sndData[i] = [];
      }
      let GroupByDueDate = {};
      let GroupByVendor = {};


      this.lstData.forEach(function (item, i) {
        let obj = {};
        _this.arrDueDate.forEach(function (value, i) {
          let DatainRow = _this.DataExport.filter(f => f.dDueDate == value && f.vendor == item.vendor && f.sCurrency == item.sCurrency)[0];
          obj["Vendor"] = item.vendor;
          obj["Cur"] = item.sCurrency;
          obj[value] = DatainRow != null ? DatainRow.nGrandTotalAmtInvoice : "";
        })
        let isDup = arrData.filter(f => f.Vendor == item.vendor && f.Cur == item.sCurrency);
        if (isDup.length == 0) {
          arrData.push(obj);
        }
      })

      let arrYSum: Array<any> = [];
      let Ysum = {};
      let sumtotal = [];
      arrData.forEach(function (value, num) {
        html += "<tr><td>" + value.Vendor + "</td>";
        let Currency = value.Cur == null ? "" : value.Cur;
        html += "<td style='text-align:center;' class='align-middle'>" + Currency + "</td>";
        let sum: Array<any> = [];
        Ysum["Cur"] = "";
        _this.arrDueDate.forEach(function (duedate, i) {
          let arr = arrData.filter(f => f).map(m => m[duedate]);
          Ysum[duedate] = arr;
          if (value[duedate] != "") {
            html += "<td style='text-align:right;' class='align-middle'>" + _this._ConvertToDecimal(value[duedate].toFixed(2)) + "</td>";
            sum.push(value[duedate]);
          }
          else if (duedate == "Total") {

            let maph = _this.DataExport.filter(f => f.vendor == value.Vendor && f.sCurrency == value.Cur).map(m => m.nGrandTotalAmtInvoice);
            let nSum = maph.reduce((acc, cur) => acc + Number(cur), 0).toFixed(2);
            sumtotal.push(nSum);
            html += "<td  style='text-align:right;' class='align-middle'>" + _this._ConvertToDecimal(nSum) + "</td>";
          } else {
            html += "<td>  </td>";
          }
        })

        html += "</tr>";
      })

      let arrdatatotal = [];
      _this.DataExport.forEach(function (item, i) {
        let obj = {};
        _this.arrDueDate.forEach(function (value, i) {
          let DatainRow = _this.DataExport.filter(f => f.dDueDate == value && f.vendor == item.vendor && f.sCurrency == item.sCurrency)[0];
          obj["Vendor"] = item.vendor;
          obj["Cur"] = item.sCurrency;
          obj[value] = DatainRow != null ? DatainRow.nGrandTotalAmtInvoice : "";
        })
        let isDup = arrdatatotal.filter(f => f.Vendor == item.vendor && f.Cur == item.sCurrency);
        if (isDup.length == 0) {
          arrdatatotal.push(obj);
        }
      })

      this.OptionGrid.nTotalItem = arrdatatotal.length;
      let nPageSize = this.System.ParseIntToZero(this.OptionGrid.nPageSize)
      let nStartIndex_Take = (this.OptionGrid.nCurrentPage - 1) * nPageSize;
      let nEndIndex_Take = nPageSize;

      var lstData2 = [];
      //this._ArrData.forEach(val => this._ArrDataBind.push(Object.assign({ cbSubDoc: val.sSupportDoc != null ? true : false }, val)));
      arrdatatotal.forEach(val => lstData2.push(Object.assign({}, val)));
      lstData2 = lstData2.splice(nStartIndex_Take, nEndIndex_Take);
      nStartItemPage = nStartIndex_Take + 1;
      nLastItemPage = nStartIndex_Take + lstData2.length;
      this.sDetailData = "Showing " + nStartItemPage + " to " + nLastItemPage + " of " + arrdatatotal.length + " Rows";

      let sumtotals = {};
      var countDay = 0;
      sumtotals["Cur"] = "";
      _this.arrDueDate.forEach(function (duedate, i) {
        let arr = arrdatatotal.filter(f => f).map(m => m[duedate]);
        sumtotals[duedate] = arr;
        countDay++;
      })
      
      sumtotals["Total"] = sumtotal;
      html += "<tr><td>Total</td>";
      //for (let value in Ysum) {
      //  let nSum = "";
      //  if (Ysum[value] != "") {
      //    nSum = Ysum[value].reduce((acc, cur) => acc + Number(cur), 0).toFixed(2);
      //  }
      //  var nVSum = _this._ConvertToDecimal(nSum) == null ? " " : _this._ConvertToDecimal(nSum);
      //  html += "<td style='text-align:right;' class='align-middle'>" + nVSum + "</td>"
      //}
      var grandTotalnSum = 0
      var count = 0;
      for (let value in sumtotals) {
        let nSum = "";
        if (sumtotals[value] != "") {
          nSum = sumtotals[value].reduce((acc, cur) => acc + Number(cur), 0).toFixed(2);
        }
        if (count > 0 && countDay != count) {
          grandTotalnSum += parseFloat(nSum);
        }
        if (countDay == count) {
          nSum = grandTotalnSum.toFixed(2)
        }
        var nVSum = _this._ConvertToDecimal(nSum) == null ? " " : _this._ConvertToDecimal(nSum);
       
        html += "<td style='text-align:right;' class='align-middle'>" + nVSum + "</td>"
        count++;
      }
      html += "</tr>"
    } else {
      html += "<tr><td colspan='" + (this.arrDueDate.length + 2) + "'>" +
        "<div *ngIf='lstData.length == 0 || ArrInvoicelength == 0' id='divNoData' class='dataNotFound' > No Data.</div>"
        + "</td>"
        + "</tr>"
    }
    if (this.lstData.length != 0 && this.dDueDate[0] != 0 && this.dDueDate[1] != 0) {
      document.getElementById('datatable').innerHTML = html;
    } if (this.lstData.length == 0) {
      html = "";
      document.getElementById('datatable').innerHTML = html;
    }
  }
  ExportExcels() {
    let _this = this;
    let pattern = new RegExp(/(\d{2})\/(\d{2})\/(\d{4})/);
    let from: any;
    let to: any;
    let isTruePattern = pattern.test(_this.dDueDate[0])

    if (isTruePattern) {
      from = _this.dDueDate[0];
      to = _this.dDueDate[1];
    } else {
      from = this.datepipe.transform(_this.dDueDate[0], 'dd/MM/yyyy');
      to = this.datepipe.transform(_this.dDueDate[1], 'dd/MM/yyyy');
    }
    this.SetHeadTable(from, to);

    let nStatus: string = this.nStatus.length > 0 ? this.nStatus.map(e => e.nStatusID).join("_") : "Null";
    let sComcode: string = this.nComcode.length > 0 ? this.nComcode.map(e => e.COMPANY_CODE).join("_") : "Null";
    let txt = this.txtPaytype != undefined ? this.txtPaytype.map(m => m.nReqType).join("_") : "Null";
    let vandor = this.nvendor == "" ? "Null" : this.nvendor;
    let dDueDateFrom = this.dDueDate != null ? from.split("/").join("_") : "";
    let dDueDateTo = this.dDueDate != null ? to.split("/").join("_") : "";
    //nStatus: nStatus,
    //  dDueDateFrom: this.dDueDate != null ? from : "",
    //    dDueDateTo: this.dDueDate != null ? to : "",

    const link = document.createElement('a');
    link.target = '_blank';
    link.href = this.System.SiteName + "api/DailyProjectd/ExportExcel/" + vandor + "/" + nStatus + "/" + dDueDateFrom + "/" + dDueDateTo + "/" + sComcode + "/" + txt + "";
    link.setAttribute('visibility', 'hidden');
    link.click();
  }
  ExportExcel() {
    let _this = this;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    let Data = JSON.stringify(_this.DataExport);
    this.http.post(this.System.SiteName + "api/DailyProjectd/ExportExcel", Data, { headers, responseType: 'arraybuffer' }).subscribe(res => {
      var blob = new Blob([res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      this.save(blob, "Dailyproject.xlsx");
    })
  }
  save(blob, fileName) {
    if (window.navigator.msSaveOrOpenBlob) { // For IE:
      navigator.msSaveBlob(blob, fileName);
    } else { // For other browsers:
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(link.href);
    }
  }
  Clear() {
    this.today7 = new Date();
    this.svendor = "";
    this.txtPaytype = undefined;
    let today7 = new Date();
    this.dDueDate = [];
    let LastDay = new Date();
    this.dDueDate[1] = this.datepipe.transform(this.today7.setDate(this.today7.getDate() + 6), 'dd/MM/yyyy');
    let lastDay: any = new Date(LastDay.setDate(LastDay.getDate() - 6));
    this.dDueDate[0] = this.dToday;
    //this.dDueDate[0] = this.datepipe.transform(this.today7.setDate(this.today7.getDate() - 6), 'dd/MM/yyyy');
    //   this.dDueDate[0] = "2020-01-10";
    //  this.dDueDate[1] = this.dToday;
    // this.dDueDate[1] = "2020-01-10";
    this.sCurrency = "THB";
    this.nStatus = [];
    this.nComcode = [];
    this.nvendor = "";
    const ua = this.System.GetUserStorage();
    if (ua) {
      ua.lstCompCode.forEach(f =>
        this.nComcode.push({COMPANY_CODE: f.sCompCode, COMPANY_NAME: f.sCompName})
      );
    }
    this.Search();
    //let html = "";
    //this.arrDueDate = [];
    //document.getElementById('datatable').innerHTML = html;
  }
  SetHeadTable(From, to) {
    this.arrDueDate = [];
    this.Numdate = From;
    //let ToDate = new Date(to.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3"))
    //while (new Date(this.Numdate.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")) < ToDate) {
    //  this.arrDueDate.push(this.Numdate)
    //  this.Numdate = this.convertDate(this.Numdate);
    //}

    let FromDate = new Date(From.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3"))
    let ToDate = new Date(to.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3"))

    for (var d = FromDate; d <= ToDate; d.setDate(d.getDate() + 1)) {
      if (d.getDay() == 6 || d.getDay() == 0) {

      }
      else {
        this.arrDueDate.push(this.System._ParseDateToFormat(d, ""));
      }
    }

    //this.arrDueDate.push(to)
    this.arrDueDate.push("Total");
  }
  setmultiselect() {
    this.settings = {
      singleSelection: false,
      idField: 'COMPANY_CODE',
      textField: 'COMPANY_NAME',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    this.settingsStatus = {
      singleSelection: false,
      idField: 'nStatusID',
      textField: 'sStatusName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  convertDate(date) {
    let SetDate = new Date(date.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3"))
    return this.datepipe.transform(SetDate.setDate(SetDate.getDate() + 1), 'dd/MM/yyyy')
  }
  _ConvertToDecimal(sVal) {
    let NoComma = (sVal + "").replace(/,/g, "");//ตัด Comma ออก
    let Data = this._decimalPipe.transform(NoComma, "1.2-2");
    return Data;
  }
  VendorNoResults(event: boolean): void {
    this.VendorNoResult = event;
  }
  VendorOnBlur() {
    if (this.VendorNoResult) {
      this.svendor = "";
    }
  }
}
